module.exports = "/fonts/fa-solid-900.woff2?64b3e814a66c2719b15abf8f7998bd73";


//////////////////
// WEBPACK FOOTER
// ./resources/assets/js/styles/fontawesome/webfonts/fa-solid-900.woff2
// module id = KeRb
// module chunks = 0 1